'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$12() {
  this.bfu = null;
  this.bfs = null;
  this.bft = false;
  this.bfq = null;
  this.bfr = false;
  this.bfv = false;
  this.bfw = false;
  this.bfu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$12 as $c_Lpresto_PrestoRouter$$anon$12 };
$p = $c_Lpresto_PrestoRouter$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$12;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$12() {
}
export { $h_Lpresto_PrestoRouter$$anon$12 as $h_Lpresto_PrestoRouter$$anon$12 };
$h_Lpresto_PrestoRouter$$anon$12.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bfu;
});
$p.t = (function() {
  if ((!this.bft)) {
    this.bfs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bft = true;
  }
  return this.bfs;
});
$p.ag = (function() {
  if ((!this.bfr)) {
    this.bfq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gT()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bfr = true;
  }
  return this.bfq;
});
$p.v = (function() {
  if ((!this.bfw)) {
    this.bfv = false;
    this.bfw = true;
  }
  return this.bfv;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$12, "presto.PrestoRouter$$anon$12", ({
  NK: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$12 as $d_Lpresto_PrestoRouter$$anon$12 };
//# sourceMappingURL=presto.-Presto-Router$$anon$12.js.map
